import { firebaseDb } from './firebase'


export class FirebaseList {
  constructor(modelClass) {
    this._modelClass = modelClass
  }

  get path() {
    return this._path
  }

  set path(value) {
    this._path = value
  }

  push(value) {
    return new Promise((resolve, reject) => {
      firebaseDb.ref(this.path)
        .push(value, error => error ? reject(error) : resolve())
    })
  }

  remove(key) {
    return new Promise((resolve, reject) => {
      firebaseDb.ref(`${this.path}/${key}`)
        .remove(error => error ? reject(error) : resolve())
    })
  }

  set(key, value) {
    return new Promise((resolve, reject) => {
      firebaseDb.ref(`${this.path}/${key}`)
        .set(value, error => error ? reject(error) : resolve())
    })
  }

  update(key, value) {
    return new Promise((resolve, reject) => {
      firebaseDb.ref(`${this.path}/${key}`)
        .update(value, error => error ? reject(error) : resolve())
    })
  }

  load() {
    return new Promise((resolve, reject) => {
      const ref = firebaseDb.ref(this.path)
      let list = []

      ref.once('value')
        .then(() => {
          ref.off()
          resolve(list)
        })
        .catch(error => reject(error))

      ref.on('child_added', snapshot => list.push(this.unwrapSnapshot(snapshot)))
    })
  }

  subscribe(emit, actions) {
    let ref = firebaseDb.ref(this.path)
    let initialized = false
    let list = []

    function emitAction(action, ...args) {
      if (actions.hasOwnProperty(action) && typeof actions[action] === 'function') {
        emit(actions[action].apply(null, args))
      }
    }

    const emitLoading = state => {
      emit({ type: 'FIREBASE_LOADING', payload: { isLoading: state, model: this._modelClass } })
    }

    if (typeof actions.onLoad !== 'undefined') {
      emitLoading(true)
    }


    ref.once('value', () => {
      initialized = true
      emitLoading(false)
      emitAction('onLoad', list)
    })

    ref.on('child_added', snapshot => {
      if (initialized) {
        emitAction('onAdd', this.unwrapSnapshot(snapshot))
      }
      else {
        list.push(this.unwrapSnapshot(snapshot))
      }
    })

    ref.on('child_changed', snapshot => {
      emitAction('onChange', this.unwrapSnapshot(snapshot))
    })

    ref.on('child_removed', snapshot => {
      emitAction('onRemove', this.unwrapSnapshot(snapshot))
    })

    this._unsubscribe = () => ref.off()
  }

  unsubscribe() {
    this._unsubscribe && this._unsubscribe()
  }

  unwrapSnapshot(snapshot) {
    let attrs = snapshot.val()
    attrs.key = snapshot.key
    return new this._modelClass(attrs)
  }
}



// WEBPACK FOOTER //
// ./src/modules/firebase/firebase-list.js